"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * The remainder is calculated so that it is always a positive number.
 * @param a Dividend. This value minus 1 applies.
 * @param n Divisor.
 */
exports.default = (a, n) => ((((a - 1) % n) + n) % n) + 1;
//# sourceMappingURL=shiftAndModulo.js.map